<template>
  <!-- Sidebar -->
  <ul
    class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
    id="accordionSidebar"
  >
    <!-- Sidebar - Brand -->
    <a
      class="sidebar-brand d-flex align-items-center justify-content-center"
      href="/"
    >
      <div class="sidebar-brand-icon">
        <img src="/img/logo_white.png" width="40px" />
      </div>
      <div class="sidebar-brand-text mx-2">GerbangChat</div>
    </a>

    <!-- Divider -->
    <hr class="sidebar-divider my-0" />

    <!-- Nav Item - Dashboard -->
    <li class="nav-item active">
      <a class="nav-link" href="/">
        <i class="fas fa-fw fa-tachometer-alt"></i>
        <span>Dashboard</span></a
      >
    </li>

    <!-- Divider -->
    <hr class="sidebar-divider" />

    <!-- Heading -->
    <div class="sidebar-heading">
      Pesan
    </div>

    <li class="nav-item">
      <router-link to="/charts" class="nav-link">
        <i class="fas fa-fw fa-chart-area"></i>
        <span>Kirim Pesan</span>
      </router-link>
    </li>

    <li class="nav-item">
      <router-link to="/charts" class="nav-link">
        <i class="fas fa-fw fa-chart-area"></i>
        <span>Kirim Broadcast</span>
      </router-link>
    </li>

    <li class="nav-item">
      <router-link to="/charts" class="nav-link">
        <i class="fas fa-fw fa-chart-area"></i>
        <span>Kirim Ke Grup</span>
      </router-link>
    </li>

    <!-- Nav Item - Pages Collapse Menu -->
    <!-- <li class="nav-item"> -->
    <!--   <a -->
    <!--     class="nav-link collapsed" -->
    <!--     href="#" -->
    <!--     data-toggle="collapse" -->
    <!--     data-target="#collapseTwo" -->
    <!--     aria-expanded="true" -->
    <!--     aria-controls="collapseTwo" -->
    <!--   > -->
    <!--     <i class="fas fa-fw fa-cog"></i> -->
    <!--     <span>Components</span> -->
    <!--   </a> -->
    <!--   <div -->
    <!--     id="collapseTwo" -->
    <!--     class="collapse" -->
    <!--     aria-labelledby="headingTwo" -->
    <!--     data-parent="#accordionSidebar" -->
    <!--   > -->
    <!--     <div class="bg-white py-2 collapse-inner rounded"> -->
    <!--       <h6 class="collapse-header">Custom Components:</h6> -->
    <!--       <router-link to="/components/buttons" class="collapse-item"> -->
    <!--         Buttons -->
    <!--       </router-link> -->
    <!--       <router-link to="/components/cards" class="collapse-item"> -->
    <!--         Cards -->
    <!--       </router-link> -->
    <!--     </div> -->
    <!--   </div> -->
    <!-- </li> -->

    <!-- Nav Item - Utilities Collapse Menu -->
    <!-- <li class="nav-item"> -->
    <!--   <a -->
    <!--     class="nav-link collapsed" -->
    <!--     href="#" -->
    <!--     data-toggle="collapse" -->
    <!--     data-target="#collapseUtilities" -->
    <!--     aria-expanded="true" -->
    <!--     aria-controls="collapseUtilities" -->
    <!--   > -->
    <!--     <i class="fas fa-fw fa-wrench"></i> -->
    <!--     <span>Utilities</span> -->
    <!--   </a> -->
    <!--   <div -->
    <!--     id="collapseUtilities" -->
    <!--     class="collapse" -->
    <!--     aria-labelledby="headingUtilities" -->
    <!--     data-parent="#accordionSidebar" -->
    <!--   > -->
    <!--     <div class="bg-white py-2 collapse-inner rounded"> -->
    <!--       <h6 class="collapse-header">Custom Utilities:</h6> -->
    <!--       <router-link to="/utilities/colors" class="collapse-item"> -->
    <!--         Colors -->
    <!--       </router-link> -->
    <!--       <router-link to="/utilities/borders" class="collapse-item"> -->
    <!--         Borders -->
    <!--       </router-link> -->
    <!--       <router-link to="/utilities/animations" class="collapse-item"> -->
    <!--         Animations -->
    <!--       </router-link> -->
    <!--       <router-link to="/utilities/other" class="collapse-item"> -->
    <!--         Other -->
    <!--       </router-link> -->
    <!--     </div> -->
    <!--   </div> -->
    <!-- </li> -->

    <!-- Divider -->
    <hr class="sidebar-divider" />

    <!-- Heading -->
    <div class="sidebar-heading">
      Pengaturan
    </div>

    <!-- Nav Item - Pages Collapse Menu -->
    <li class="nav-item">
      <a
        class="nav-link collapsed"
        href="#"
        data-toggle="collapse"
        data-target="#collapsePages"
        aria-expanded="true"
        aria-controls="collapsePages"
      >
        <i class="fas fa-fw fa-folder"></i>
        <span>Pages</span>
      </a>
      <div
        id="collapsePages"
        class="collapse"
        aria-labelledby="headingPages"
        data-parent="#accordionSidebar"
      >
        <div class="bg-white py-2 collapse-inner rounded">
          <h6 class="collapse-header">Login Screens:</h6>
          <router-link to="/login" class="collapse-item">
            Login
          </router-link>
          <router-link to="/register" class="collapse-item">
            Register
          </router-link>
          <router-link to="/forgot-password" class="collapse-item">
            Forgot Password
          </router-link>
          <div class="collapse-divider"></div>
          <h6 class="collapse-header">Other Pages:</h6>
          <router-link to="/not-found" class="collapse-item">
            404 Page
          </router-link>
          <router-link to="/blank" class="collapse-item">
            Blank Page
          </router-link>
        </div>
      </div>
    </li>

    <!-- Nav Item - Charts -->
    <li class="nav-item">
      <router-link to="/charts" class="nav-link">
        <i class="fas fa-fw fa-chart-area"></i>
        <span>Charts</span>
      </router-link>
    </li>

    <!-- Nav Item - Tables -->
    <li class="nav-item">
      <router-link to="/tables" class="nav-link">
        <i class="fas fa-fw fa-table"></i>
        <span>Tables</span>
      </router-link>
    </li>

    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" />

    <!-- &#60;&#33;&#45;&#45; Sidebar Toggler (Sidebar) &#45;&#45;&#62; -->
    <!-- <div class="text-center d-none d-md-inline"> -->
    <!--   <button class="rounded-circle border-0" id="sidebarToggle"></button> -->
    <!-- </div> -->
    <!--  -->
    <!-- &#60;&#33;&#45;&#45; Sidebar Message &#45;&#45;&#62; -->
    <!-- <div class="sidebar-card d-none d-lg-flex"> -->
    <!--   <img -->
    <!--     class="sidebar-card-illustration mb-2" -->
    <!--     src="img/undraw_rocket.svg" -->
    <!--     alt="..." -->
    <!--   /> -->
    <!--   <p class="text-center mb-2"> -->
    <!--     <strong>SB Admin Pro</strong> is packed with premium features, -->
    <!--     components, and more! -->
    <!--   </p> -->
    <!--   <a -->
    <!--     class="btn btn-success btn-sm" -->
    <!--     href="https://startbootstrap.com/theme/sb-admin-pro" -->
    <!--     >Upgrade to Pro!</a -->
    <!--   > -->
    <!-- </div> -->
  </ul>
  <!-- End of Sidebar -->
</template>

<script>
export default {
  name: "Sidebar",
};
</script>
